import moment from 'moment'

export const isDateValid = (dateValue: string | Date) => {
  const formattedDate = moment(dateValue).format('MM/DD/YYYY')
  return !isNaN(new Date(dateValue).getTime()) && moment(formattedDate, 'MM/DD/YYYY', true).isValid()
}
